"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__or__wifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "deb8c5dc-2e39-422f-a052-d32f6c84a85d",
    "data-name": "Wifi_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f7da40c-bf01-475e-8e3d-cb402f4233e3",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "6720f0f5-aa7c-476c-a7a6-d052aa6260d3",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 132,
    r: 8,
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    id: "886c952f-d625-4f4c-a61e-73fe96dc37d7",
    "data-name": "<Pfad>",
    d: "M20,59.5a107.43,107.43,0,0,1,152,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "04609427-f1db-4926-9925-f4125c27324f",
    "data-name": "<Pfad>",
    d: "M42,82.51a76.76,76.76,0,0,1,108.6,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "22370b46-9bc4-436a-a44f-8bbb8d5d2557",
    "data-name": "<Pfad>",
    d: "M64.6,105.08a44.62,44.62,0,0,1,63.12,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "broadband-mid"), /*#__PURE__*/React.createElement("g", {
    id: "d1a1a348-4e11-4a1e-8917-04b1afc1b49a",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "8d540986-afb9-4e3e-9665-d488524086af",
    "data-name": "Wifi_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#deb8c5dc-2e39-422f-a052-d32f6c84a85d"
  })));
}

var _default = ic_broadband__or__wifi;
exports.default = _default;